angular
  .module('optionsAdd')
  .component('optionsAdd', {
    template: require('./options-add.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', 'AuthService', 'envService', 'Upload',
      function _($rootScope, $scope, $resource, $route, $location, $window, $translate, AuthService, envService, Upload) {
        $scope.showEmployeeView = $rootScope.gShowEmployeeView;
        $scope.showUserView = $rootScope.gShowUserView;
        $scope.doLogout = $rootScope.gLogout;
        $rootScope.mainmenu = 'service';
        $rootScope.menu = 'goods';
        const API_URL = envService.read('apiUrl'); // eslint-disable-line
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }
        this.loginMember = AuthService.loginMember();
        this.isTh = this.loginMember && this.loginMember.COUNTRY_CODE === 'TH';
        this.META = { medias: [''], THUMBNAIL_URL: '', MAX_QUANTITY: 1 };
        this.META.durations = Array(101).fill().map((x, i) => i * 5);

        function initialze(ctrl) {
          ctrl.TYPES = ctrl.meta.goodsTypes.map(goodsType => goodsType.TYPE);
          ctrl.PRODUCTS = ctrl.meta.carTypes.map(carType => ({ GROUP_GOODS_ID: carType.ITEMCD, ITEMCD: carType.ITEMCD, ITEMNM: carType.ITEMNM, DURATION: '0', DURATION_TXT: '' }));
        }

        $resource(`${API_URL}/admin/meta/subscription/add `).get().$promise
          .then((data) => {
            this.meta = data;
            initialze(this);
          })
          .catch((err) => {
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        this.removeProduct = (targetProduct) => {
          if (this.PRODUCTS.length < 2) {
            alert($translate.instant('최소 하나이상의 차종을 선택 해야 합니다.'));
            return;
          }
          this.PRODUCTS = this.PRODUCTS.filter(product => product !== targetProduct);
        };
        this.removeType = (targetType) => {
          if (this.TYPES.length < 2) {
            alert($translate.instant('최소 하나이상의 상품을 선택 해야 합니다.'));
            return;
          }
          this.TYPES = this.TYPES.filter(type => type !== targetType);
        };
        this.submit = () => {
          if (!this.META.OPTION_NAME || this.META.OPTION_NAME.length < 1) {
            alert($translate.instant('옵션명을 입력해주세요.'));
            return;
          }
          if (!this.META.OPTION_NAME_EN || this.META.OPTION_NAME_EN.length < 1) {
            alert($translate.instant('옵션명을 입력해주세요.'));
            return;
          }
          if (!this.META.DETAIL_DESCRIPTION || this.META.DETAIL_DESCRIPTION.length < 1) {
            alert($translate.instant('설명을 작성해주세요.'));
            return;
          }
          if (!this.META.DETAIL_DESCRIPTION_EN || this.META.DETAIL_DESCRIPTION_EN.length < 1) {
            alert($translate.instant('상세영문 설명을 입력해주세요.'));
            return;
          }
          if (!this.META.MAX_QUANTITY || this.META.MAX_QUANTITY.length < 1) {
            alert($translate.instant('1회 주문 가능 수량을 입력해주세요.'));
            return;
          }

          if (this.PRODUCTS.filter((product) => {
            if (product.PRICE === null || product.PRICE === undefined) {
              return true;
            }
            if (product.OPTION_PRICE === null || product.OPTION_PRICE === undefined) {
              return true;
            }
            return product.EMPLOYEE_PRICE === null || product.EMPLOYEE_PRICE === undefined;
          }).length > 0) {
            alert($translate.instant('가격을 입력해주세요.'));
            return;
          }
          if (this.PRODUCTS.filter(product => product.DURATION_TXT.length < 1).length > 0) {
            alert($translate.instant('세차 시간 표기를 입력해주세요.'));
            return;
          }

          let goods = [];
          for (let i = 0; i < this.TYPES.length; i += 1) {
            const products = this.PRODUCTS.map((product) => { // eslint-disable-line
              const newProduct = $.extend({}, product); // eslint-disable-line
              newProduct.TYPE = this.TYPES[i];
              newProduct.OPTION_NAME = this.META.OPTION_NAME;
              newProduct.OPTION_NAME_EN = this.META.OPTION_NAME_EN;
              newProduct.DETAIL_DESCRIPTION = this.META.DETAIL_DESCRIPTION;
              newProduct.DETAIL_DESCRIPTION_EN = this.META.DETAIL_DESCRIPTION_EN;
              newProduct.MAX_QUANTITY = this.META.MAX_QUANTITY;
              newProduct.THUMBNAIL_URL = this.META.THUMBNAIL_URL;
              newProduct.URLS = this.META.medias;
              return newProduct;
            });
            goods = goods.concat(products);
          }
          $resource(`${API_URL}/admin/goods/options/add`).save({ OPTIONS: goods }).$promise
            .then(() => {
              $location.path('/service/options');
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };

        this.addImage = () => {
          this.META.medias.push('');
        };

        this.uploadImage = (media, files, index) => {
          if (files && files.length) {
            const file = files[0];
            Upload.upload({
              url: `${API_URL}/admin/file/options`,
              file,
            }).progress(() => {
            }).success((data, status, headers, config) => { // eslint-disable-line no-unused-vars
              media = data.url;
              this.META.medias[index] = data.url;
              alert(this.META.medias);
            });
          }
        };

        this.removeImage = function removeImage(url, index) { // eslint-disable-line no-unused-vars
          const URLS = [];
          if (this.META.medias) {
            this.META.medias.forEach((item) => {
              if (item !== url) {
                URLS.push(item);
              }
            });
          }
          this.META.medias = URLS;
        };
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/options-add/options-add.component.js